// extracted by mini-css-extract-plugin
export default {"burger":"Header_burger__k5ipm"};